import googleLogo from "assets/google_on_white.png";
import { memo, useCallback } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import {
  reactSelectStyles,
  reactSelectTheme,
} from "shared/config/react-select";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../../../../shared/ui/FormGroup/FormGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "shared/icons";
import "./GoogleSearch.styles.css";
import { components } from "react-select";
import "./GoogleSearch.styles.css";
import { debounce } from "shared/utils";
import { googleSearchService } from "features/GoogleSearch";

const googleSearchStyles = {
  ...reactSelectStyles,
  menu: (baseStyles) => ({
    ...baseStyles,
    paddingBottom: "0.4rem",
  }),
};

const MenuWithFooter = ({ children, ...props }) => (
  <components.Menu {...props}>
    {children}
    <div className="search-menu-footer">
      <small>Powered by</small>
      <img src={googleLogo} alt="Google"></img>
    </div>
  </components.Menu>
);

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      {props.selectProps.menuIsOpen ? (
        <FontAwesomeIcon className="close-icon" icon={Icons.close} />
      ) : (
        <FontAwesomeIcon className="search-icon" icon={Icons.search} />
      )}
    </components.DropdownIndicator>
  );
};

const GoogleSearch = function GoogleSearch({
  name,
  register = (name) => ({}),
  error = null,
  label = null,
  addon = null,
  control = null,
  withGoogleIcon = false,
  popoverRef = (el) => ({}),
  displayAs = Form.Group,
  defaultOptions = null,
  md = 6,
  ...props
}) {
  const loadOptionsDebounced = useCallback(
    debounce((inputValue, callback) => {
      if (inputValue.length === 0) return callback(defaultOptions);
      return googleSearchService
        .getTravelPlaces(inputValue)
        .then((response) =>
          callback(
            response.data.data.map((option) => ({
              value: option.id,
              label: option.name,
              country_code: option.country_code,
            }))
          )
        )
        .catch((error) =>
          callback([
            {
              value: "error",
              label:
                error.response?.data?.message ??
                "Error occured while loading data...",
              isDisabled: true,
            },
          ])
        );
    }, 1000),
    []
  );

  return (
    <FormGroup
      controlId={name}
      label={label}
      addon={addon}
      error={error}
      displayAs={displayAs}
      md={md}
    >
      <Controller
        name={name}
        shouldUnregister
        control={control}
        render={({ field: { ref: formRef, onBlur, onChange, ...rest } }) => (
          <AsyncSelect
            inputId={name}
            ref={(el) => {
              popoverRef(el);
              formRef(el);
            }}
            cacheOptions
            loadOptions={loadOptionsDebounced}
            onChange={(value) => onChange(value)}
            defaultOptions
            theme={reactSelectTheme}
            styles={googleSearchStyles}
            placeholder="Type to search…"
            components={{ DropdownIndicator, Menu: MenuWithFooter }}
            className={`w-100 ${error ? "is-invalid" : ""}`}
            {...rest}
            {...props}
          />
        )}
      />
    </FormGroup>
  );
};

GoogleSearch.WithPopover = withPopover(GoogleSearch);
export default memo(GoogleSearch);
